import React, { useEffect } from "react";

function LandForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  
  // Debug logging
  useEffect(() => {
    console.log('🏞️ LandForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    
    // Boolean dəyərləri düzgün çevir
    const finalValue = type === "select-one" && (value === "true" || value === "false")
      ? value === "true"
      : value;

    console.log(`🔧 Field changed: ${name} = ${finalValue} (type: ${typeof finalValue})`);

    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: finalValue,
    });
  };

  return (
    <div className="landForm">
      {/* Torpaq sahəsi (sot) */}
      <div>
        <h3>
          Torpaq sahəsi (sot) <span>*</span>
          <span className="tooltip-icon" title="1 sot = 100 m²">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="area" 
          min="1" 
          max="10000"
          placeholder="10"
          required 
          onChange={handleChange} 
        />
      </div>

      {/* Torpaq növü */}
      <div>
        <h3>
          Torpaq növü <span>*</span>
          <span className="tooltip-icon" title="Torpağın istifadə məqsədi">ℹ️</span>
        </h3>
        <select name="landType" required defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Yaşayış">Yaşayış (ev tikmək üçün)</option>
          <option value="Kənd təsərrüfatı">Kənd təsərrüfatı (əkinçilik)</option>
          <option value="Ticarət">Ticarət (biznes üçün)</option>
          <option value="Sənaye">Sənaye (zavod, anbar)</option>
          <option value="Bağ">Bağ / Bağça</option>
        </select>
      </div>

      {/* Sənəd növü */}
      <div>
        <h3>
          Sənəd növü <span>*</span>
          <span className="tooltip-icon" title="Hüquqi sənəd tipi">ℹ️</span>
        </h3>
        <select name="documentType" required defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Çıxarış (Kupça)">Çıxarış (Kupça) ✅</option>
          <option value="Müqavilə">Müqavilə (Alqı-Satqı)</option>
          <option value="Bələdiyyə sənədi">Bələdiyyə sənədi</option>
          <option value="İcarə müqaviləsi">İcarə müqaviləsi</option>
          <option value="Sənədsiz">Sənədsiz ⚠️</option>
        </select>
      </div>

      {/* Su xətti */}
      <div>
        <h3>
          Su xətti <span>*</span>
          <span className="tooltip-icon" title="İçməli su çəkilişi">ℹ️</span>
        </h3>
        <select name="hasWater" required defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Elektrik */}
      <div>
        <h3>
          Elektrik <span>*</span>
          <span className="tooltip-icon" title="Elektrik şəbəkəsi">ℹ️</span>
        </h3>
        <select name="hasElectricity" required defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Qaz xətti */}
      <div>
        <h3>
          Qaz xətti <span>*</span>
          <span className="tooltip-icon" title="Təbii qaz boru kəməri">ℹ️</span>
        </h3>
        <select name="hasGas" required defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      {/* Yol */}
      <div>
        <h3>
          Yol <span>*</span>
          <span className="tooltip-icon" title="Asfalt yol varmı?">ℹ️</span>
        </h3>
        <select name="hasRoad" defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Asfalt">Asfalt yol ✅</option>
          <option value="Torpaq">Torpaq yol</option>
          <option value="Yoxdur">Yol yoxdur ❌</option>
        </select>
      </div>

      {/* Qonşuluq */}
      <div>
        <h3>
          Qonşuluq <span>*</span>
          <span className="tooltip-icon" title="Ətraf infrastruktur">ℹ️</span>
        </h3>
        <select name="neighborhood" defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Yaşayış massivi">Yaşayış massivi içində</option>
          <option value="Kənd">Kənd ərazisi</option>
          <option value="Təcrid olunmuş">Təcrid olunmuş ərazi</option>
          <option value="Şəhər kənarı">Şəhər kənarı</option>
        </select>
      </div>

      {/* Torpağın meylliliyi */}
      <div>
        <h3>
          Torpağın meylliliği
          <span className="tooltip-icon" title="Düz torpaq tikinti üçün daha uyğundur">ℹ️</span>
        </h3>
        <select name="slope" defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Düz">Düz (meyilsiz) ✅</option>
          <option value="Yüngül meyilli">Yüngül meyilli</option>
          <option value="Dik">Dik meyilli</option>
        </select>
      </div>

      {/* Məqsəd */}
      <div>
        <h3>
          İstifadə məqsədi
          <span className="tooltip-icon" title="Torpaq nə üçün satılır?">ℹ️</span>
        </h3>
        <select name="purpose" defaultValue="" onChange={handleChange}>
          <option value="" disabled>Seçin</option>
          <option value="Tikinti">Ev / Villa tikinti</option>
          <option value="Əkinçilik">Əkinçilik / Bağçılıq</option>
          <option value="İnvestisiya">İnvestisiya</option>
          <option value="Biznes">Biznes məqsədi</option>
        </select>
      </div>
    </div>
  );
}

export default LandForm;